var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDietaryRestrictionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.99609,
    y: 2.99622,
    width: 18.0075,
    height: 18.0075,
    rx: 5,
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2766 7.29798L8.08829 12.7152C7.97431 12.9055 7.97044 13.1422 8.07813 13.3361C8.18581 13.53 8.38872 13.6518 8.61051 13.6556H11.5957V16.3798C11.5894 16.6566 11.7711 16.9026 12.0375 16.978C12.3039 17.0533 12.5876 16.939 12.7272 16.6999L15.9155 11.2846C16.0295 11.0944 16.0334 10.8577 15.9257 10.6638C15.818 10.4699 15.6151 10.3481 15.3933 10.3443H12.4081V7.62012C12.4154 7.34294 12.234 7.09602 11.9673 7.02009C11.7006 6.94417 11.4164 7.05853 11.2766 7.29798Z",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietaryRestrictionIcon);
export default __webpack_public_path__ + "static/media/dietary-restriction-icon.2bfd5f3989a3650940fb2c7162bf9f86.svg";
export { ForwardRef as ReactComponent };